import { Turbo } from '@hotwired/turbo-rails';
import ControllerWithSignal from '../scripts/controller-with-signal';

export default class extends ControllerWithSignal {
  static values = {
    reload: Boolean,
    url: String,
  };

  connectWithSignal(signal) {
    this.element.showModal();
    this.turboFrame = this.element.closest('turbo-frame');
    this.interval = setInterval(() => {
      this.reload();
    }, 3_000);

    document.addEventListener('visibilitychange', this.visibilityChange, { signal });
    this.turboFrame.addEventListener('turbo:before-frame-render', this.beforeFrameRender, {
      signal,
    });
    this.turboFrame.addEventListener('turbo:before-morph-attribute', this.beforeMorphAttribute, {
      signal,
    });
  }

  disconnectWithSignal() {
    this.element.close();
    clearInterval(this.interval);
  }

  reloadValueChanged() {
    if (this.reloadValue) {
      Turbo.visit(this.urlValue || ''); // loads url or reloads the page
      return;
    }
  }

  visibilityChange = () => {
    this.reload();
  };

  async reload() {
    if (document.hidden) return;

    // setting src will reload the frame
    this.turboFrame.src = location.pathname;
  }

  // use morphing when reloading the frame
  beforeFrameRender = (e) => {
    e.detail.render = Turbo.morphTurboFrameElements;
  };

  // prevent closing of the dialog when reloading the frame
  beforeMorphAttribute = (e) => {
    if (e.target.tagName === 'DIALOG' && e.detail.attributeName === 'open') {
      e.preventDefault();
    }
  };
}
